module.exports = __webpack_public_path__ + "img/B272.f413cda6.png";